import React from "react";
import { Config } from "../MachineTaskConstants";

const ControlUI = ({ onButtonClick, isExecuting, isMaxReached }) => {
  return (
    <div className="mb-4">
      <div className="d-flex align-items-center mb-3">
        <h4 className="m-0 font-weight-bold">Panel sterowania maszyną</h4>
      </div>

      <div className="row">
        {Config.map((item, index) => {
          if (!item || !item.options) return null;

          return (
            <div className="col-12 col-md-6 col-lg-4 mb-3" key={`config-${index}`}>
              <div className="card h-100 shadow-sm border-0 bg-light">
                <div className="card-body p-3 d-flex flex-column justify-content-between">
                  <div className="d-flex justify-content-between align-items-center mb-2">
                    <span className="font-weight-bold text-dark h6 mb-0">
                      {item.name}
                    </span>
                    <span className="badge badge-light text-muted border">
                      {item.taskType}
                    </span>
                  </div>

                  <div className="btn-group w-100 mt-2" role="group">
                    {item.options.map((option, optionIndex) => {
                      const btnVariant =
                        item.taskType === "RESTART"
                          ? "btn-outline-danger"
                          : option.value === 1
                          ? "btn-outline-success"
                          : option.value === 0
                          ? "btn-outline-secondary"
                          : "btn-outline-primary";

                      return (
                        <button
                          key={optionIndex}
                          type="button"
                          className={`btn ${btnVariant} btn-sm d-flex align-items-center justify-content-center`}
                          onClick={onButtonClick}
                          id={`${item.taskType}-${option.value !== undefined ? option.value : ''}`}
                          disabled={isExecuting || isMaxReached}
                          title={isMaxReached ? "Osiągnięto limit 3 zleceń naraz" : `${item.name}: ${option.name}`}
                        >
                          <span>{option.name}</span>
                        </button>
                      );
                    })}
                  </div>
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default ControlUI;
